import React, { createContext, useContext } from 'react';
import { useBreakpoint } from '@grnhse/seedling/lib/birch/layouts/breakpoints';

export const BreakpointContext = createContext('xl');

export const useBreakpointContext = () => {
  const context = useContext(BreakpointContext);
  if (!context) {
    throw new Error(
      'useBreakpointContext not used within a BreakpointContext.Provider'
    );
  }
  return context;
};

export const BreakpointContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const breakpoint = useBreakpoint();

  return (
    <BreakpointContext.Provider value={breakpoint}>
      {children}
    </BreakpointContext.Provider>
  );
};
